import React from 'react'

import { Shimmer } from '@wartek-id/shimmer'

const QuizPagePlaceholder = () => {
  return (
    <>
      <div className="p-4" role="alert" aria-busy="true">
        <div className="mb-4">
          <Shimmer
            height={12}
            noOfLines={3}
            className="mb-1"
            style={{ width: '100%' }}
          />
        </div>
        {[...Array(4)].map((_, idx) => (
          <div
            key={idx}
            className="relative p-4 w-full mx-auto mb-4 bg-white rounded shadow-card"
          >
            <Shimmer
              height={12}
              noOfLines={2}
              className="w-full mb-1"
              style={{ width: '100%' }}
            />
          </div>
        ))}
      </div>
    </>
  )
}

export default QuizPagePlaceholder
